// Resolves to undefined when reCAPTCHA is not configured for the region
export const getRecaptchaToken = (action = 'submit') => {
    if (!window.GOOGLE_RECAPTCHA_KEY || !window.grecaptcha) return Promise.resolve(undefined)

    return new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
            try {
                window.grecaptcha.execute(window.GOOGLE_RECAPTCHA_KEY, { action }).then(resolve, reject)
            } catch (error) {
                reject(error)
            }
        })
    })
}
